/* =====================================================================
 * Calculation Data Base
 * ===================================================================*/

export default {
  correctives: [
    {
      name: 'Calcário Itaú',
      city: 'Itaú de Minas',
      uf: 'MG',
      cao: 43,
      mgo: 9,
      prnt: 95,
      pn: 99,
      type: 'Dolomítico'
    },
    {
      name: 'Calcário Itaú',
      city: 'Itapeva',
      uf: 'SP',
      cao: 30,
      mgo: 20,
      prnt: 83,
      pn: 103,
      type: 'Dolomítico'
    },
    {
      name: 'Calcário Itaú',
      city: 'Salto de Pirapora',
      uf: 'SP',
      cao: 31,
      mgo: 19,
      prnt: 82,
      pn: 103,
      type: 'Dolomítico'
    },
    {
      name: 'Calcário Zincal',
      city: 'Paracatu',
      uf: 'MG',
      cao: 28,
      mgo: 17,
      prnt: 90,
      pn: 92,
      type: 'Dolomítico'
    },
    {
      name: 'Calcário Itaú',
      city: 'Rio Branco do Sul',
      uf: 'PR',
      cao: 45,
      mgo: 4,
      prnt: 92,
      pn: 90,
      type: 'Calcítico'
    },
    {
      name: 'Calcário Itaú',
      city: 'Pinheiro Machado',
      uf: 'RS',
      cao: 41,
      mgo: 4,
      prnt: 82,
      pn: 83,
      type: 'Calcítico'
    },
    {
      name: 'Calcário Itaú',
      city: 'Sobradinho',
      uf: 'DF',
      cao: 35,
      mgo: 14,
      prnt: 95,
      pn: 97,
      type: 'Dolomítico'
    },
    {
      name: 'Calcário Itaú',
      city: 'Nobres',
      uf: 'MT',
      cao: 35,
      mgo: 12,
      prnt: 90,
      pn: 92,
      type: 'Dolomítico'
    },
    {
      name: 'Calcário Itaú',
      city: 'Nobres',
      uf: 'MT',
      cao: 35,
      mgo: 12,
      prnt: 82,
      pn: 92,
      type: 'Dolomítico'
    },
    {
      name: 'Calcário Itaú',
      city: 'Xambioá',
      uf: 'TO',
      cao: 31,
      mgo: 15,
      prnt: 90,
      pn: 93,
      type: 'Dolomítico'
    },
    {
      name: 'Calcário Itaú',
      city: 'Xambioá',
      uf: 'TO',
      cao: 47,
      mgo: 3,
      prnt: 82,
      pn: 92,
      type: 'Calcítico'
    },
    {
      name: 'Cal Fértil HP',
      city: 'Itaú de Minas',
      uf: 'MG',
      cao: 53,
      mgo: 12,
      prnt: 127,
      pn: 125,
      type: 'Dolomítico'
    },
    {
      name: 'Cal Fértil HP',
      city: 'Itapeva',
      uf: 'SP',
      cao: 40,
      mgo: 27,
      prnt: 137,
      pn: 139,
      type: 'Dolomítico'
    },
    {
      name: 'Cal Fértil VP',
      city: 'Itapeva',
      uf: 'SP',
      cao: 48,
      mgo: 32,
      prnt: 160,
      pn: 165,
      type: 'Dolomítico'
    },
    {
      name: 'Cal Fértil VF',
      city: 'Itapeva',
      uf: 'SP',
      cao: 48,
      mgo: 32,
      prnt: 160,
      pn: 165,
      type: 'Dolomítico'
    },
  ],

  saturation: {
    calcium: [
      {
        value: 0,
        type: 'Defic',
        min: 0,
        max: 39.9,
        index: 1
      },
      {
        value: 40,
        type: 'Médio',
        min: 40,
        max: 49.9,
        index: 2
      },
      {
        value: 50,
        type: 'Equil',
        min: 50,
        max: 59.9,
        index: 3
      },
      {
        value: 60,
        type: 'Alto',
        min: 60,
        max: 99999999,
        index: 4
      }
    ],
    magnesium: [
      {
        value: 0,
        type: 'Defic',
        min: 0,
        max: 6.9,
        index: 1
      },
      {
        value: 7,
        type: 'Médio',
        min: 7,
        max: 11.9,
        index: 2
      },
      {
        value: 12,
        type: 'Equil',
        min: 12,
        max: 19.9,
        index: 3
      },
      {
        value: 20,
        type: 'Alto',
        min: 20,
        max: 99999999,
        index: 4
      }
    ]
  },
};
